import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { Lock, ShieldCheck, Zap, FileText } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="py-10 md:py-20 px-5 bg-[#0F1C30] scroll-mt-0" data-id="element-56">
      <div className="max-w-3xl mx-auto text-center" data-id="element-57">
        <FadeIn data-id="element-58">
          <p className="font-sans text-sm text-brand-orange font-bold tracking-[0.2em] uppercase mb-4" data-id="element-59">
            — ÚLTIMO PASO —
          </p>

          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-bold leading-tight mb-6" data-id="element-60">
            ¿Cuántas noches más vas a terminar sintiéndote culpable?
          </h2>

          <p className="font-sans text-lg md:text-xl text-slate-300 leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-61">
            Tienes el método. Tienes la garantía. Tienes el precio más bajo que
            existirá para este producto.
          </p>

          <p className="font-sans text-lg md:text-xl text-brand-orange font-bold mb-8" data-id="element-62">
            La única pregunta es: ¿empiezas hoy o sigues esperando?
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-63">
          <CTAButton mainText="SÍ, QUIERO RECUPERAR LA CALMA EN MI CASA AHORA" className="shadow-2xl shadow-brand-orange/30 py-6 sm:py-8" href="https://pay.hotmart.com/K105564779B?checkoutMode=10" data-id="element-64" />
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 mt-5 text-xs text-slate-400" data-id="element-65">
            <span className="inline-flex items-center gap-1" data-id="element-66">
              <Lock className="w-3.5 h-3.5" data-id="element-67" />
              Pago seguro por Hotmart
            </span>
            <span className="text-slate-600" data-id="element-68">·</span>
            <span className="inline-flex items-center gap-1" data-id="element-69">
              <ShieldCheck className="w-3.5 h-3.5" data-id="element-70" />
              Cifrado de nivel bancario
            </span>
            <span className="text-slate-600" data-id="element-71">·</span>
            <span className="inline-flex items-center gap-1" data-id="element-72">
              <Zap className="w-3.5 h-3.5" data-id="element-73" />
              Acceso inmediato
            </span>
            <span className="text-slate-600" data-id="element-74">·</span>
            <span className="inline-flex items-center gap-1" data-id="element-75">
              <FileText className="w-3.5 h-3.5" data-id="element-76" />
              Garantía de 7 días
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}